import { Component, inject, Input, OnChanges, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MdlSelectCampaign } from '../../mdl-select-campaing/mdl-select-campaing';
import { Api } from '../../../services/api';
import { CommonModule } from '@angular/common';
import { MdlmanageContract } from '../../mdl-manage-contract/mdl-manage-contract';

@Component({
  selector: 'app-con-camp',
  imports:[CommonModule],
  templateUrl: './con-camp.html',
  styleUrls: ['./con-camp.css']
})
export class ConCamp implements OnInit, OnChanges {
  constructor(private dialog: MatDialog) {}
  @Input() contacto: any;

  public contratos: any[] = [];

  private api = inject(Api);

  openModal(): void {
    const dialogRef = this.dialog.open(MdlSelectCampaign, {
      width: '500px',
      panelClass: 'custom-dialog-container',
      data: {} 
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Campaña seleccionada:', result);
      }
    });
  }

  ngOnInit(): void {
    if (this.contacto) this.loadRelatedData();
  }
  
  ngOnChanges(): void {
    if (this.contacto) this.loadRelatedData();
  }

  loadRelatedData(): void {
    console.log('🔍 Cargando datos relacionados para contacto:', this.contacto);
    this.api.getContractsByContact(this.contacto.contacto_id).subscribe((response: any) => {
      if (Array.isArray(response.contratos)) {
        this.contratos = response.contratos;
        console.log('Contratos cargados:', this.contratos);
      } else {
        console.error(
          'Respuesta inesperada al obtener contratos por contacto:',
          response
        );
      }
    });

  }

  
    openMdlCreateContract() {
      this.dialog.open(MdlmanageContract, {
        minWidth: '800px',
        maxHeight: '900px',
        panelClass: 'mat-dlg-class',
        data: {
          mode: 'create',
        },
      });
    }

}